import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useSyncExternalStore } from "react"
import { Toaster as Sonner } from "sonner";

import { getPageTheme, subscribeToPageTheme } from "@/app/themeOnPage"

const Toaster = ({
  ...props
}: React.ComponentProps<typeof Sonner>): React.JSX.Element => {
  // The toast takes its colors from the page tokens, so its own theme must match the page.
  const theme = useSyncExternalStore(subscribeToPageTheme, getPageTheme)

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      // Keep phone toasts clear of the iOS home indicator.
      mobileOffset={{ bottom: "calc(16px + env(safe-area-inset-bottom, 0px))" }}
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          // This app's Tailwind v4 @theme (index.css) prefixes its tokens, so
          // the popover/border/radius vars are --color-popover / --color-border
          // / --radius-lg. The stock shadcn names (--popover/--border/--radius)
          // are undefined here, which made toasts render with no background
          // (invisible). Point at the real tokens.
          "--normal-bg": "var(--color-popover)",
          "--normal-text": "var(--color-popover-foreground)",
          "--normal-border": "var(--color-border)",
          "--border-radius": "var(--radius-lg)"
        } as React.CSSProperties
      }
      {...props} />
  );
}

export { Toaster }
